import { render, staticRenderFns } from "./index-sipm.vue?vue&type=template&id=4662a04c&"
import script from "./index-sipm.vue?vue&type=script&lang=js&"
export * from "./index-sipm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports